<template>
  <div class="timeline scroll">
    <h2>Histórico</h2>
    <div class="timeline-centered mt-4">
      <article
        class="timeline-entry"
        v-for="time in timeline"
      >
        <div class="timeline-entry-inner">
          <div class="timeline-icon">
            <i :class="time.icon" />
          </div>
          <div class="timeline-label">
            <div
              class="message"
              v-html="time.user_message"
            />
            <div
              class="time"
              v-b-tooltip.bottom="formatDate(time.created_at)"
            >
              <span class="icon mr-1"><i class="fa fa-clock-o" /></span> {{ time.created_at | ago }}
            </div>
          </div>
        </div>
      </article>
    </div>
  </div>
</template>

<script>
import { VBTooltip } from 'bootstrap-vue';
import dayjs from '../../core/dayjs';

export default {
  directives: {
    'b-tooltip': VBTooltip,
  },

  mounted () {
    this.getTimeline();
  },

  props: ['id'],

  data () {
    return {
      timeline: null,
    };
  },

  // events: {
  //   leadUpdated: function () {
  //     this.getTimeline();

  //     // The propagation for each path will stop when a listener callback is fired along that path, unless the callback returns true.
  //     return true;
  //   },
  // },

  methods: {
    getTimeline () {
      this.$http.get(`/user/${this.id}/timeline`)
        .then((response) => {
          this.timeline = response.data;
        })
        .catch((error) => {
          console.log(error.responseJSON);
        });
    },

    formatDate (date) {
      return dayjs(date).format('LDT');
    },
  },
};
</script>
